<mat-paginator aria-label="Select page"
  class="orgApp-table-pagination"
  [length]="totalRecords"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 20]"
  (page)="onChangePage($event)"
>
</mat-paginator>
